import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { loadMathPicker } from "../picker/math-module";

import { bindHarmonyWindowContribution } from "../window/contributions/harmony-contribution";

import { bindHarmonyCanvasModules } from "../canvas/contributions/harmony/modules";

import { HarmonyEnvContribution } from "./contributions/harmony-contribution";

export function bindHarmonyEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, HarmonyEnvContribution)) || (container.bind(HarmonyEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(HarmonyEnvContribution));
}

export function loadHarmonyEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadHarmonyEnv.__loaded || (loadHarmonyEnv.__loaded = !0, bindHarmonyEnv(container), 
    bindHarmonyCanvasModules(container), bindHarmonyWindowContribution(container), loadPicker && loadMathPicker(container));
}

loadHarmonyEnv.__loaded = !1;

export function initHarmonyEnv() {
    loadHarmonyEnv();
}
//# sourceMappingURL=harmony.js.map